import React, { useState } from "react"
import PatientImage from "./PatientImage"
import Observations from "../../../../common/Fhir/Observation"
import ImmunizationList from "../../../../common/Fhir/ImmunizationList"
import ConditionList from "../../../../common/Fhir/ConditionList"
import Encounter from "../../../../common/Fhir/Encounter"
import CarePlan from "../../../../common/Fhir/CarePlan"
import Person from "../../../../common/Fhir/Person"
import ResourceList from "../../../../common/Fhir/ResourceList"
import {
    getPatientName,
    getPatientPhone,
    getPatientEmail,
    getPatientHomeAddress,
    getPatientAge,
    getPath,
    getPatientMRN,
    getAllPages
} from "."
import "./PatientDetail.less"
import { useData } from "@pure-ptr/react"
import { fetchResources, GetPatientDetails } from "../../../../store/api/fhir-api"
import { Box, Dialog, DialogTitle, Grid, IconButton, Modal } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';

/**
 * Renders the detail page.
 */
export const PatientDetail = (props: any) => {
    const { claimId, isOpen, handleClose, isFhirConfigured } = props;
    const [groups, setGroups] = useState<any>({});
    const [selectedSubCat, setSelectedSubCat] = useState<any>();
    const [patient, setPatient] = useState<any>();

    const { } = useData(async () => {
        try {
            if (claimId && isFhirConfigured && isOpen) {
                const response = await GetPatientDetails(claimId);
                const result = getAllPages(response);
                if (result) {
                    const patientDetail = getPath(response, `entry.${0}.resource`);
                    if (patientDetail) {

                        setPatient(patientDetail);

                        const observations = await fetchResources('/api/v1/Observation/', patientDetail.id);
                        if (observations) {
                            const processedObservation = getAllPages(observations);
                            processedObservation.forEach(observation => {
                                result.push(observation)
                            });
                        }

                        const conditions = await fetchResources('/api/v1/Condition/', patientDetail.id);
                        if (conditions) {
                            const processedCondition = getAllPages(conditions);
                            processedCondition.forEach(condition => {
                                result.push(condition)
                            });
                        }

                        const diagnosticReports = await fetchResources('/api/v1/DiagnosticReport/', patientDetail.id);
                        if (diagnosticReports) {
                            const processedDiagnosticReport = getAllPages(diagnosticReports);
                            processedDiagnosticReport.forEach(diagnosticReport => {
                                result.push(diagnosticReport)
                            });
                        }

                        const encounters = await fetchResources('/api/v1/Encounter/', patientDetail.id);
                        if (encounters) {
                            const processedEncounter = getAllPages(encounters);
                            processedEncounter.forEach(encounter => {
                                result.push(encounter)
                            });
                        }

                        let tempGroups = {};
                        result.forEach(entry => {
                            let resourceType = getPath(entry, "resource.resourceType") || "Other";
                            let type = resourceType;

                            if (type == "Observation") {
                                let subCat = String(
                                    getPath(entry, "resource.category.0.text") ||
                                    getPath(entry, "resource.category.coding.0.code") ||
                                    getPath(entry, "resource.category.0.coding.0.code") ||
                                    "Other"
                                ).toLowerCase();

                                subCat = subCat.split(/\-+/).map(token => {
                                    return token.charAt(0).toUpperCase() + token.substr(1)
                                }).join(" ");
                                type += " - " + subCat;
                            }

                            if (!Array.isArray(tempGroups[type])) {
                                tempGroups[type] = []
                            }
                            tempGroups[type].push(entry)
                        })

                        if (!selectedSubCat || !tempGroups[selectedSubCat]) {
                            setSelectedSubCat(Object.keys(tempGroups)[0] || "")
                        }

                        setGroups(tempGroups);

                    }
                }
                return response;
            }
        }
        catch (error) {
            console.error(error);
        }

    }, [claimId, isFhirConfigured, isOpen]);



    const renderPatient = () => {
        return (
            <div className="panel panel-default patient col-xs-12">
                <div className="row">
                    <div className="col-xs-10 col-md-11">
                        <div className="patient-row">
                            <div className="col-xs-7 patient-name">
                                <h3 className="pull-left text-primary">
                                    {getPatientName(patient) || "Unknown"}
                                </h3>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-4 col-sm-2 col-lg-1 text-right text-muted">Gender:</div>
                            <div className="col-xs-8 col-sm-3 col-lg-3 text-left">
                                {patient.gender || "Unknown"}
                            </div>
                            <div className="col-xs-4 col-sm-2 col-lg-1 text-right text-muted">DOB:</div>
                            <div className="col-xs-8 col-sm-5 col-lg-3 text-left">
                                {patient.birthDate || "Unknown"}
                            </div>

                            <div className="col-xs-4 col-sm-2 col-lg-1 text-right text-muted">Age:</div>
                            <div className="col-xs-8 col-sm-3 col-lg-3 text-left">
                                {getPatientAge(patient) || "Unknown"}
                            </div>
                            <div className="col-xs-4 col-sm-2 col-lg-1 text-right text-muted">Email</div>
                            <div className="col-xs-8 col-sm-5 col-lg-3 text-left">
                                {getPatientEmail(patient) || "Unknown"}
                            </div>
                            <div className="col-xs-4 col-sm-2 col-lg-1 text-right text-muted">Phone:</div>
                            <div className="col-xs-8 col-sm-3 col-lg-3 text-left">
                                {getPatientPhone(patient) || "Unknown"}
                            </div>
                            <div className="col-xs-4 col-sm-2 col-lg-1 text-right text-muted">Address:</div>
                            <div className="col-xs-8 col-sm-5 col-lg-3 text-left">
                                {getPatientHomeAddress(patient) || "Unknown"}
                            </div>
                            <div className="col-xs-4 col-sm-2 col-lg-1 text-right text-muted">ID:</div>
                            <div className="col-xs-8 col-sm-3 col-lg-3 text-left">
                                {patient.id || "Unknown"}
                            </div>
                            <div className="col-xs-4 col-sm-2 col-lg-1 text-right text-muted">MRN:</div>
                            <div className="col-xs-8 col-sm-5 col-lg-3 text-left">
                                {getPatientMRN(patient) || "Unknown"}
                            </div>
                            {
                                patient.deceasedBoolean || patient.deceasedDateTime ?
                                    (
                                        <div className="col-xs-4 col-sm-2 col-lg-1 text-right text-muted">
                                            <span className="deceased-label">Deceased:</span>
                                        </div>
                                    ) :
                                    null
                            }
                            {
                                patient.deceasedBoolean || patient.deceasedDateTime ?
                                    (
                                        <div className="col-xs-8 col-sm-5 col-lg-3 text-left">
                                            {
                                                patient.deceasedDateTime ?
                                                    <span>{patient.deceasedDateTime}</span> :
                                                    <span>{patient.deceasedBoolean ? "Yes" : "No"}</span>
                                            }
                                        </div>
                                    ) :
                                    null
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const renderResources = (type) => {
        let items = groups[type] || [];
        if (!items.length) {
            return (
                <p className="text-center text-muted">
                    No items of type "{type}" found
                </p>
            )
        }

        if (type.indexOf("Observation") === 0) {
            return <Observations resources={items} />;
        }

        switch (type) {
            case "Immunization":
                return <ImmunizationList resources={items} />;
            case "Condition":
                return <ConditionList resources={items} />
            case "Encounter":
                return <Encounter resources={items} />;
            case "CarePlan":
                return <CarePlan resources={items} />;
            case "Patient":
            case "Practitioner":
            case "RelatedPerson":
                return <Person resources={items} title={type} />;
            default:
                return <ResourceList resources={items} type={type} />;
        }
    }

    return (
        <Dialog
            fullWidth
            scroll="paper"
            maxWidth="lg"
            open={isOpen} onClose={handleClose}>
            <DialogTitle>
                <Grid container alignItems='center'>
                    <Grid item xs={11}>
                        {'Patient Details'}
                    </Grid>
                    <Grid item xs={1} className='text-right'>
                        <IconButton aria-label="close" onClick={handleClose} size="large">
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>

            {patient ?
                <div className="page patient-detail-page">
                    <div className="container">

                        {renderPatient()}
                        {
                            groups ?
                                <div className="row patient-details">
                                    <br />
                                    <div className="col-xs-12 col-sm-3">
                                        <ul className="list-group">
                                            {
                                                Object.keys(groups).sort().map((k, i) => (
                                                    <a
                                                        href="#"
                                                        key={i}
                                                        className={"list-group-item" + (k === selectedSubCat ? " active" : "")}
                                                        onClick={e => {
                                                            e.preventDefault()
                                                            setSelectedSubCat(k)
                                                        }}
                                                    >
                                                        <b className="badge pull-right">{groups[k] ? groups[k].length : 0}</b>
                                                        <b>{k}</b>
                                                    </a>
                                                ))
                                            }
                                        </ul>
                                    </div>
                                    <div className="col-xs-12 col-sm-9">
                                        {renderResources(selectedSubCat)}
                                    </div>
                                </div> :
                                <div className="row">
                                    <div className="col-xs-12 text-muted text-center">
                                        No additional details for this patient
                                    </div>
                                </div>
                        }
                    </div>

                </div> : <div style={{justifyContent:'center', display:'flex'}}>No details for this patient</div>}
        </Dialog>
    )
}

export default PatientDetail;
